module.exports = __webpack_public_path__ + "img/hayden.8a5be0cd.png";